// Voeg hier je eigen custom JavaScript toe. Let op: Gebruik geen jQuery, maar vanilla JavaScript.

// On document ready:
document.addEventListener('DOMContentLoaded', function () {
    // Add your custom JavaScript here.
    // NOTE: This script will be loaded on every page AND in the Gutenberg editor.
    console.log('Page loaded!');

    const progressCircle = document.querySelector(".progress");
    const percentageText = document.querySelector(".percentage");
    const radius = 140; // nieuwe straal
    const circumference = 2 * Math.PI * radius;
    const target = 91; // eindpercentage
    const duration = 2000; // animatie in ms

    progressCircle.style.strokeDasharray = circumference;
    progressCircle.style.strokeDashoffset = circumference;

    let start = null;

    function animate(timestamp) {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);

      const current = Math.floor(progress * target);

      // tekst updaten
      percentageText.textContent = current + "%";

      // stroke offset updaten
      const offset = circumference - (current / 100) * circumference;
      progressCircle.style.strokeDashoffset = offset;

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    }

    requestAnimationFrame(animate);

});


window.addEventListener("scroll", function () {
  const scrollPos = window.scrollY;
  const body = document.body; // of document.querySelector("header") etc.

  if (scrollPos > 100) {
    body.classList.add("scrolled");
  } else {
    body.classList.remove("scrolled");
  }
});



document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.wp-block-video').forEach(function(videoContainer) {

    videoContainer.addEventListener('click', function() {
      const video = this.querySelector('video');
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    const video = videoContainer.querySelector('video');
    video.addEventListener('play', function() {
      videoContainer.classList.add('is-playing');
    });

    video.addEventListener('pause', function() {
      videoContainer.classList.remove('is-playing');
    });
  });
  
});


